import { API } from '@/utils/configs/axios.config'
import { ISeoData, ISeoSession } from '@/types/seo.interface'

const SeoService = {
  getSeoData: async (path: string) => {
    const seoData = (
      await API.post<ISeoData>('/public/api/v1/site-seo', {
        path,
      })
    ).data

    return seoData
  },

  getSeoSession: async () => {
    const seoSession = (await API.get<ISeoSession>('/public/api/v1/seo-session')).data

    return seoSession
  },
}

export default SeoService
